import BaseHttpClient from '../../base'
import { apis, getApiUrl } from '../api-config'

/**
 * Teacher auth
 */
class AuthTeacherAPI extends BaseHttpClient {
  async LoginViaToken (token) {
    return this.getAsync('via-token/' + token)
  }
}

export default new AuthTeacherAPI('v1/teachers', 'Teacher', getApiUrl(apis.AuthAPI))
